import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './Scan.css';
import Heading from '../../../utls/Heading';

const Scan = () => {
  return (
    <>
     <div className="header-line mt-5 scan-line"></div>
    <div className="scan-section pb-4">
        <div className="container">
            <div className="row">
                <div className="col-md-6 mt-5 scan-img d-flex justify-content-center align-items-md-center">
                    <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/Scanner.png" alt="" loading="lazy"  />
                </div>
                <div className="col-md-6  mt-3">
                    <Heading className="customheadings"> <span className="">Scan</span> to Connect</Heading>
                    <p className="scan-one fw-bold">Planning next Board Meeting or Organization event?</p>
                    <p className="scan-two">Simply scan the QR code below to get in touch with our travel experts instantly.
                        We’re here to help you every step of the way!</p>
                    <span className="fs5 fw-bold mt-3">Why Scan the QR Code?</span>
                    <ul className="ul-fs mt-3">
                        <li><b>Instant Assistance:</b> Connect with our team in seconds.</li>
                        <li><b>Exclusive Offers:</b> Access special deals and promotions.</li>
                        <li><b>Personalized Support: </b>Get recommendations tailored to your travel needs.</li>
                        <li><b>Travel Updates:</b> Stay informed about the latest travel guidelines and restrictions.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Scan